import { useContext, useEffect, useState } from 'react';
import { CreateBookingFormContext } from '../CreateBookingForm.context';

const useBookingSummaryHook = () => {
  const { formState } = useContext(CreateBookingFormContext);
  const [state, setState] = useState({});

  useEffect(() => {
    if (formState) {
      const { guestsDetails, roomsDetails, bookingDates } = formState;
      updateState({ rooms: roomsDetails, bookingDates, guestsDetails });
    }
  }, [formState]);

  const actions = {};

  function updateState(object) {
    setState(previousState => ({ ...previousState, ...object }));
  }

  return { state, actions };
};

export default useBookingSummaryHook;
